<template>
  <div>
    <button
      class="submit"
      @click="submit"
      :class="{ disabled: !donationValid }"
      :disabled="!donationValid"
    >
      {{ $t('donationForm.confirm') }}
    </button>
    <div class="secure-payment-container">
      <div class="secure-payment">
        <font-awesome-icon icon="lock" />
        {{ $t('donationForm.paySecurely') }}
      </div>
    </div>
  </div>
</template>

<script>
import storeDonation from '@/lib/donation/storeDonation'
import { useDonationStore } from '@/stores/donation'
import { usePaymentStore } from '@/stores/payment'
import { useRootStore } from '@/stores/root'

export default {
  name: 'SubmitButton',
  setup () {
    const rootStore = useRootStore()
    const donationStore = useDonationStore()
    const paymentStore = usePaymentStore()

    return {
      donationStore, paymentStore, rootStore
    }
  },
  computed: {
    thankYouPath () { return this.$t('routeNames.thankYou') },
    donationValid () { return this.rootStore.formValid && this.rootStore.turnstileToken }
  },
  emits: ['submitted'],
  methods: {
    submit () {
      if (this.donationValid) {
        this.paymentStore.setPaymentProcessing(true)
        storeDonation(this, localStorage)
        this.$emit('submitted')
      } else {
        this.touchFields()
      }
    },
    touchFields () {
      this.rootStore.touchValidationFields(true)
      if (document.querySelector('div.error')) {
        this.$scrollToElement('.error')
      } else {
        this.$scrollToTop()
      }
      this.$nextTick(function () {
        this.rootStore.touchValidationFields(false)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  button.submit {
    border: none;
    padding: 0.6em 1em;
    text-align: center;
    width: 100%;
    margin-top: 1em;
    background-color: orange;
    color: black;
    text-shadow: 0 1px 0 white;
    box-shadow: 2px 2px 7px rgba(black, 0.3);

    &.disabled {
      opacity: 0.7;
    }
  }

  .secure-payment-container {
    margin-top: 0.5rem;
    display: flex;
    justify-content: center;
  }
</style>
